import baseStyles from '../Base/Base.styles'
import merge from 'lodash/merge'
import basePlayButton from '../BasePlayButton/BasePlayButton.styles'
export default (props) => {

  const {base, playButton} = props

  let jss = {
    root: {
      ...baseStyles(base),
      '& .pb': basePlayButton(playButton),
    }
  }



  return jss
}